/**
 * @module store/settings/getters
 *
 * @version 1.0.6
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив поддерживаемых токенов
 *
 * @returns {array}
 */
const settings = state => state.settings;


/**
 * Getter: Возвращает текущую используемую сеть
 *
 * @returns {array}
 * @since Version 1.0.3
 */
const foundationsCategories = state => (state.settings.foundationsCategories ? state.settings.foundationsCategories : []);


/**
 * Getter: Возвращает список кактегорий стартов
 *
 * @returns {array}
 * @since Version 1.0.4
 */
const startsCategories = state => (state.settings.startsCategories ? state.settings.startsCategories : []);

/**
 * Getter: Возвращает цену челеджа со старатми
 *
 * @returns {number}
 * @since Version 1.0.6
 */
const startsPrice = state => (state.settings.startsPrice ? parseFloat(state.settings.startsPrice) : 0);


/**
 * Getter: Возвращает список кактегорий акций
 *
 * @returns {array}
 * @since Version 1.0.5
 */
const pointsCategories = state => (state.settings.pointsCategories ? state.settings.pointsCategories : []);


export default {
  foundationsCategories,
  pointsCategories,
  settings,
  startsCategories,
  startsPrice,
};
